import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const navLinks = [
  { label: '首页', to: '/' },
  { label: '新闻资讯', to: '/news' },
  { label: '影视作品', to: '/works' },
  { label: '个人资料', to: '/profile' },
  { label: '专题合集', to: '/specials' },
  { label: '关于', to: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    setMenuOpen(false);
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : '/search');
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-background-50/60 backdrop-blur-sm'
      }`}
    >
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 h-16 md:h-20 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-primary-700 text-background-50 font-heading font-bold text-sm">
            张
          </span>
          <span className="font-heading text-base md:text-lg font-bold text-foreground-950 whitespace-nowrap">
            张柏芝资讯站
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7 font-label text-sm text-foreground-700">
          {navLinks.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="cursor-pointer whitespace-nowrap hover:text-primary-700 transition-colors"
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="hidden md:flex items-center">
          <div className="flex items-center bg-background-100 border border-background-200 rounded-full px-3 py-2 w-56 lg:w-64">
            <i className="ri-search-line text-foreground-500 text-sm w-4 h-4 flex items-center justify-center"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索张柏芝相关内容"
              className="bg-transparent outline-none border-none text-sm text-foreground-800 placeholder:text-foreground-400 ml-2 w-full"
            />
          </div>
          <button
            type="submit"
            className="ml-2 cursor-pointer whitespace-nowrap bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-label px-4 py-2 rounded-full transition-colors"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="lg:hidden cursor-pointer w-9 h-9 flex items-center justify-center rounded-md text-foreground-800 text-xl"
          aria-label="打开菜单"
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <form onSubmit={handleSearch} className="flex items-center bg-background-100 border border-background-200 rounded-full px-3 py-2 mb-4">
            <i className="ri-search-line text-foreground-500 text-sm w-4 h-4 flex items-center justify-center"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索张柏芝相关内容"
              className="bg-transparent outline-none border-none text-sm text-foreground-800 placeholder:text-foreground-400 ml-2 w-full"
            />
            <button type="submit" className="cursor-pointer whitespace-nowrap text-accent-600 text-sm font-label ml-2">
              搜索
            </button>
          </form>
          <nav className="flex flex-col gap-1 font-label text-sm text-foreground-700">
            {navLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer whitespace-nowrap px-2 py-3 rounded-md hover:bg-background-100 hover:text-primary-700 transition-colors"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}